export default __webpack_public_path__ + "static/media/875.e8fcc106.png";